import React, { useState } from 'react';
import { ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
interface Column {
  key: string;
  label: string;
  sortable?: boolean;
}
interface DataTableProps {
  columns: Column[];
  data: any[];
  className?: string;
}
export function DataTable({
  columns,
  data,
  className = ''
}: DataTableProps) {
  const [sortKey, setSortKey] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const handleSort = (key: string) => {
    if (sortKey === key) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDirection('asc');
    }
  };
  const sortedData = sortKey ? [...data].sort((a, b) => {
    const aVal = a[sortKey];
    const bVal = b[sortKey];
    if (typeof aVal === 'string') {
      return sortDirection === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    }
    return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
  }) : data;
  return <div className={`overflow-x-auto ${className}`} data-id="element-294">
      <table className="w-full" data-id="element-295">
        <thead className="bg-au-green-light" data-id="element-296">
          <tr data-id="element-297">
            {columns.map(col => <th key={col.key} className={`px-6 py-4 text-left text-sm font-bold text-charcoal ${col.sortable ? 'cursor-pointer hover:bg-au-green hover:text-white transition-colors' : ''}`} onClick={() => col.sortable && handleSort(col.key)} data-id="element-298">
                <div className="flex items-center gap-2" data-id="element-299">
                  {col.label}
                  {col.sortable && sortKey === col.key && (sortDirection === 'asc' ? <ChevronUpIcon size={16} data-id="element-300" /> : <ChevronDownIcon size={16} data-id="element-301" />)}
                </div>
              </th>)}
          </tr>
        </thead>
        <tbody className="bg-white" data-id="element-302">
          {sortedData.map((row, index) => <tr key={index} className="border-b border-gray-border hover:bg-gray-50 transition-colors" data-id="element-303">
              {columns.map(col => <td key={col.key} className="px-6 py-4 text-sm text-gray-700" data-id="element-304">
                  {row[col.key]}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}